
import { mapState } from 'vuex';
import TransitionFadeHeight from '@/transitions/TransitionFadeHeight';
import ReviewContentType from '@/enums/ReviewContentType';

export default {
  name: 'AppReviewInfoSectionListPc',
  components: { TransitionFadeHeight },
  props: {
    review: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      collapsed: true,
      messageRowsCount: -1
    };
  },
  computed: {
    ...mapState('widget', ['widget']),
    ...mapState('reviewSettings', ['reviewSettings']),
    expandedMessage() {
      if (
        this.widget.use_review_keyword_filter &&
        this.review.filtered_message_with_highlight
      )
        return this.review.filtered_message_with_highlight.replace(
          /==(.*?)==/g,
          '<mark>$1</mark>'
        );
      return this.review.filtered_message;
    },
    collapsedMessage() {
      if (!this.collapseAllMessage) return this.expandedMessage;

      let storeName = '';
      if (this.reviewSettings.show_store_name_prefix && this.review.store_name)
        storeName = `[${this.review.store_name}] `;
      return storeName + this.widget.collapsed_title;
    },
    collapseAllMessage() {
      return this.widget.message_initial_rows === 0;
    },
    collapsePartialMessage() {
      return this.widget.message_initial_rows > 0;
    },
    collapsible() {
      if (this.review.content_type === ReviewContentType.RESTRICTED)
        return false;
      if (this.collapseAllMessage) return true;
      if (this.collapsePartialMessage) {
        if (
          this.messageRowsCount > this.widget.message_initial_rows ||
          this.review.evaluation_properties?.length > 0
        )
          return true;
      }
      return false;
    },
    visibleRows() {
      return Math.min(this.messageRowsCount, this.widget.message_initial_rows);
    }
  },
  watch: {
    messageRowsCount(newRowsCount, oldRowsCount) {
      const initialRows = this.widget.message_initial_rows;
      if (oldRowsCount > initialRows && newRowsCount > initialRows) return;
      if (oldRowsCount <= initialRows && newRowsCount <= initialRows) return;

      this.collapsed = this.collapsible;
    }
  },
  mounted() {
    if (this.collapsePartialMessage) {
      window.addEventListener('resize', this.calcMessageRowsCount);
      setTimeout(() => {
        this.calcMessageRowsCount();
      });
    }
    this.collapsed = this.collapsible;
  },
  beforeDestroy() {
    if (this.collapsePartialMessage) {
      window.removeEventListener('resize', this.calcMessageRowsCount);
    }
  },
  methods: {
    clickMessageToggle() {
      if (!this.collapsible) return;
      this.collapsed = !this.collapsed;
    },
    calcMessageRowsCount() {
      const collapsedHeight = this.$refs.collapsed_message.scrollHeight;
      const exposedHeight = this.$refs.exposed_message.scrollHeight;
      const newMaxHeight =
        collapsedHeight === 0 ? exposedHeight : collapsedHeight;

      const messageLineHeight = 18;
      const newMessageRowsCount = newMaxHeight / messageLineHeight;
      if (newMessageRowsCount === this.messageRowsCount) return;

      this.messageRowsCount = newMessageRowsCount;
    }
  }
};
